import React from 'react';

import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { api } from '../../../../../core/api';
import CompanyTabContent from '../shared/CompanyTabContent';
import { useCompanyTabLoader } from '../shared/useCompanyTabLoader';
import { CompanyDocumentsContextProvider } from './CompanyDocumentsContext/CompanyDocumentsContext';
import CompanyDocumentsList from './CompanyDocumentsList';

const CompanyDocuments: React.FC = () => {
  const { data, isLoading } = useCompanyTabLoader(api.company.getDocumentsData);

  return (
    <CompanyTabContent isLoading={isLoading}>
      <TableGridApiContextProvider>
        <CompanyDocumentsContextProvider>
          <CompanyDocumentsList data={data?.files} />
        </CompanyDocumentsContextProvider>
      </TableGridApiContextProvider>
    </CompanyTabContent>
  );
};

export default CompanyDocuments;
